(function () {
  var contentImages = document.querySelectorAll('.article__content img');

  contentImages.forEach(function (image) {
    var source = image.getAttribute('src');

    if (!source) return;

    var imageUrl;

    try {
      imageUrl = new URL(source, window.location.origin);
    } catch (error) {
      return;
    }

    var isShopifyImage =
      imageUrl.hostname === 'cdn.shopify.com' ||
      imageUrl.pathname.indexOf('/cdn/shop/') !== -1 ||
      imageUrl.pathname.indexOf('/s/files/') !== -1;

    if (!isShopifyImage) return;

    var widths = [360, 540, 720, 960, 1200, 1600, 2000];
    var sources = widths.map(function (width) {
      var candidateUrl = new URL(imageUrl.href);
      candidateUrl.searchParams.set('width', width);
      return candidateUrl.href + ' ' + width + 'w';
    });
    var fallbackUrl = new URL(imageUrl.href);

    fallbackUrl.searchParams.set('width', 1200);
    image.setAttribute('srcset', sources.join(', '));
    image.setAttribute(
      'sizes',
      '(max-width: 525px) calc(100vw - 116px), (max-width: 768px) 90vw, calc(60vw - 230px)'
    );
    image.setAttribute('src', fallbackUrl.href);
    image.setAttribute('loading', 'lazy');
    image.setAttribute('decoding', 'async');
  });
})();
